import React from "react";
import { PlusCircle, DashCircle, Trash } from "react-bootstrap-icons";

function HotSheetPriority({ priority, onUpdate, onDelete }) {
  const addSubPriority = () => {
    const updated = {
      ...priority,
      subPriorities: [
        ...priority.subPriorities,
        { no: priority.subPriorities.length + 1, text: "" },
      ],
    };
    onUpdate(updated);
  };

  const removeSubPriority = () => {
    if (priority.subPriorities.length === 0) return;
    onUpdate({
      ...priority,
      subPriorities: priority.subPriorities.slice(0, -1),
    });
  };

  const updateSubPriority = (index, text) => {
    const subPriorities = priority.subPriorities.map((sp, i) =>
      i === index ? { ...sp, text } : sp
    );
    onUpdate({ ...priority, subPriorities });
  };

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center mb-1">
        <label className="me-2 fw-semibold">Objective {priority.no}</label>
        <span role="button" className="me-1" onClick={addSubPriority}>
          <PlusCircle size={20} />
        </span>
        <span role="button" className="me-2" onClick={removeSubPriority}>
          <DashCircle size={20} />
        </span>
        <span role="button" className="text-danger" onClick={() => onDelete(priority)}>
          <Trash size={20} />
        </span>
      </div>
      <input
        type="text"
        className="form-control"
        value={priority.text}
        onChange={(e) => onUpdate({ ...priority, text: e.target.value })}
      />
      <ul className="mt-1">
        {priority.subPriorities.map((sp, i) => (
          <li key={i} className="my-1">
            <input
              type="text"
              className="form-control"
              value={sp.text}
              onChange={(e) => updateSubPriority(i, e.target.value)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default HotSheetPriority;
